import { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { Modal } from "./GearBits";

/* Printable QR tag: scanning opens the bag's inventory record at /gear?bag={id}. */
export default function QRTagModal({ bag, onClose }) {
  const url = `${window.location.origin}/gear?bag=${bag.id}`;
  const areaRef = useRef(null);

  const print = () => {
    const w = window.open("", "_blank", "width=420,height=560");
    w.document.write(`<html><head><title>Bag tag — ${bag.name}</title>
      <style>body{font-family:sans-serif;text-align:center;padding:24px}
      .tag{border:2px dashed #999;padding:24px;display:inline-block}
      h2{margin:12px 0 2px}p{margin:2px 0;color:#555;font-size:13px}</style></head>
      <body><div class="tag">${areaRef.current?.innerHTML || ""}</div>
      <script>window.onload=()=>{window.print();window.close();}</script></body></html>`);
    w.document.close();
  };

  return (
    <Modal title={`QR tag — ${bag.name}`} onClose={onClose}>
      <div className="text-center space-y-4" data-testid="qr-tag-modal">
        <div ref={areaRef} className="inline-block border-2 border-dashed border-zinc-400 p-6">
          <QRCodeSVG value={url} size={180} level="M" data-testid="qr-code" />
          <h2 className="font-heading font-900 text-lg mt-3 mb-0.5">{bag.name}</h2>
          {bag.owner_name && <p className="text-sm text-zinc-600 m-0">Owner: {bag.owner_name}</p>}
          {bag.luggage_tag && <p className="text-sm text-zinc-600 m-0">Tag: {bag.luggage_tag}</p>}
          <p className="text-xs text-zinc-500 mt-1">Scan to open this bag's inventory record<br />TravelerPulse.pro</p>
        </div>
        <p className="text-xs text-muted-foreground">
          Print it, laminate it, attach it to the bag. Anyone scanning it opens the bag record —
          only you (signed in) can see the full inventory.
        </p>
        <button onClick={print} data-testid="qr-print"
          className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold bg-primary text-white hover:bg-blue-700">
          <Printer className="w-4 h-4" /> Print tag
        </button>
      </div>
    </Modal>
  );
}
